import React, { Component } from "react";
import "./styles.css";

class Icon extends Component {

  // ===============================================================================================
  render() {
    return (
      <div className={"icon" +
        ((this.props.type) ? " icon--" + this.props.type : "") +
        ((this.props.className) ? " " + this.props.className : "")}>
      </div>
    );
  }

}



export default Icon
